import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';

import { WpService } from '../service/wp.service'

import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  animations: [
    trigger('menuToggle', [
      state('1', style({
        height: 0
      })),
      state('*', style({
        height: "*"
      })),
      transition('1 => *', animate('400ms ease-in')),
      transition('* => 1', animate('400ms ease-out'))
    ])
  ]
})
export class MenuComponent implements OnInit {

  collaps = false;
  menuToggle = true;


  private data: any;

  constructor(private wp: WpService, private router: Router) {
    wp.get('menu').subscribe(
      data => {
        this.data = data;
      },
      error => {
        console.error(error)
      }
    )
    router.events.subscribe(() => {this.menuToggle = true})
  }

  hover(menu) {
    menu.open()
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/leonhard/Projekte/braungardt/angular/src/app/menu/menu.component.ts